import { useEffect } from "react";
import { TypeButton } from "../../atoms/fonts/Types";
import { IcoBrand } from "../../atoms/icons/IcoBrand";
import {
	IconArrowRight,
	IconClose,
	IconFlagES,
	IconFlagUS,
} from "../../atoms/icons/Icons";
import { useT } from "../../../i18n/LanguageContext";
import "./Nav.css";

const LINKS = [
	{ href: "#services", key: "services" },
	{ href: "#sellaris", key: "work" },
	{ href: "#process", key: "process" },
	{ href: "#about", key: "about" },
	{ href: "#contact", key: "contact" },
];

function LangSwitch({ lang, setLang, switchLabel, variant }) {
	return (
		<div
			className={`Nav_langSwitch Nav_langSwitch--${variant}`}
			role="group"
			aria-label={switchLabel}
		>
			<button
				type="button"
				className={`Nav_langBtn ${lang === "en" ? "is-active" : ""}`}
				onClick={() => setLang("en")}
				aria-pressed={lang === "en"}
				aria-label="English"
			>
				<IconFlagUS className="Nav_langFlag" />
				<span>EN</span>
			</button>
			<button
				type="button"
				className={`Nav_langBtn ${lang === "es" ? "is-active" : ""}`}
				onClick={() => setLang("es")}
				aria-pressed={lang === "es"}
				aria-label="Español"
			>
				<IconFlagES className="Nav_langFlag" />
				<span>ES</span>
			</button>
		</div>
	);
}

function NavLinkList({ onLinkClick, t, mobile }) {
	return (
		<ul className="Nav_list">
			{LINKS.map((link, i) => (
				<li key={link.key} style={mobile ? { "--i": i } : undefined}>
					<a className="Nav_link" href={link.href} onClick={onLinkClick}>
						<TypeButton className="-Nav_type">{t(`nav.${link.key}`)}</TypeButton>
						{mobile && (
							<span className="Nav_linkArrow" aria-hidden="true">
								<IconArrowRight />
							</span>
						)}
					</a>
				</li>
			))}
		</ul>
	);
}

export function Nav({ open, setOpen, isMobile }) {
	const { t, lang, setLang } = useT();
	const close = () => setOpen(false);

	useEffect(() => {
		if (!isMobile || !open) return;
		const onKey = (e) => {
			if (e.key === "Escape") setOpen(false);
		};
		document.addEventListener("keydown", onKey);
		return () => document.removeEventListener("keydown", onKey);
	}, [isMobile, open, setOpen]);

	if (isMobile) {
		return (
			<>
				<div
					className={`Nav_backdrop ${open ? "is-open" : ""}`}
					onClick={close}
					aria-hidden="true"
				/>
				<aside
					className={`Nav_drawer ${open ? "is-open" : ""}`}
					role="dialog"
					aria-modal={open}
					aria-hidden={!open}
					aria-label="Site menu"
				>
					<div className="Nav_drawerHeader">
						<IcoBrand className="Nav_drawerBrand" />
						<button
							type="button"
							className="Nav_drawerClose"
							onClick={close}
							aria-label="Close menu"
						>
							<IconClose />
						</button>
					</div>

					<nav className="Nav_drawerNav" aria-label="Primary">
						<NavLinkList onLinkClick={close} t={t} mobile />
					</nav>

					<div className="Nav_drawerFooter">
						<span className="Nav_drawerFooterLabel">{t("lang.switchTo")}</span>
						<LangSwitch
							lang={lang}
							setLang={setLang}
							switchLabel={t("lang.switchTo")}
							variant="drawer"
						/>
					</div>
				</aside>
			</>
		);
	}

	return (
		<nav className="Nav" aria-label="Primary">
			<NavLinkList onLinkClick={undefined} t={t} mobile={false} />
			<LangSwitch
				lang={lang}
				setLang={setLang}
				switchLabel={t("lang.switchTo")}
				variant="desktop"
			/>
		</nav>
	);
}
